import TreePicker from './TreePicker';
import withLocale from 'rsuite/es/IntlProvider/withLocale';
export default withLocale(['Picker'])(TreePicker);